"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RATING = exports.PROS = exports.PRODUCT_REVIEW = exports.NAME_OR_ALIAS = exports.CONTENT = exports.CONS = void 0;
const CONTENT = exports.CONTENT = 'content';
const RATING = exports.RATING = 'rating';
const NAME_OR_ALIAS = exports.NAME_OR_ALIAS = 'name-or-alias';
const PRODUCT_REVIEW = exports.PRODUCT_REVIEW = 'product-review';
const PROS = exports.PROS = 'pros';
const CONS = exports.CONS = 'cons';
